import type { Location } from '../types/campaign';

export function generateCampaignName(
  objective: string,
  caseType?: string,
): string {
  const date = new Date();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();

  const objectiveNames = {
    lead_form: 'Lead Generation',
    phone_call: 'Call',
    website_click: 'Traffic',
  };

  const caseName = caseType
    ? caseType
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : '';

  return `${caseName} ${objectiveNames[objective]} - ${month} ${year}`;
}

export function generateMarketName(
  // objective: string,
  locations: Location[],
): string {
  const date = new Date();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();

  const locationString =
    locations.length > 0 ? locations.map((l) => l.name).join(', ') : 'All US';

  return `${locationString} - ${month} ${year}`;
}

export function generateAdName(objective: string): string {
  const date = new Date();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();

  const typeNames = {
    lead_form: 'Lead Form',
    phone_call: 'Call',
    website_click: 'Click',
  };

  return `${typeNames[objective]} Ad - ${month} ${year}`;
}
